var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavAgencies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "agencies") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1",
    id: "3.0-Browse-Jobs-Mobile",
    transform: "translate(-149.000000, -56.000000)",
    fill: "#FAC00A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "agencies",
    transform: "translate(149.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.96,5.47826087 L11.96,21 L21.6533989,21 L23,21 L23,5.47826087 L11.96,5.47826087 Z M18.6914847,10.2113924 L20.6845153,10.2113924 L20.6845153,8.27722374 L18.6914847,8.27722374 L18.6914847,10.2113924 Z M14.2754847,10.2113924 L16.2680083,10.2113924 L16.2680083,8.27722374 L14.2754847,8.27722374 L14.2754847,10.2113924 Z M18.6914847,14.53728 L20.6845153,14.53728 L20.6845153,12.6035905 L18.6914847,12.6035905 L18.6914847,14.53728 Z M14.2754847,14.53728 L16.2680083,14.53728 L16.2680083,12.6035905 L14.2754847,12.6035905 L14.2754847,14.53728 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,21 L10.12,21 L10.12,0 L0,0 L0,21 Z M6.17279985,5.87346197 L8.04540953,5.87346197 L8.04540953,3.89835011 L6.17279985,3.89835011 L6.17279985,5.87346197 Z M2.02409527,5.87346197 L3.89622858,5.87346197 L3.89622858,3.89835011 L2.02409527,3.89835011 L2.02409527,5.87346197 Z M6.17279985,10.2401426 L8.04540953,10.2401426 L8.04540953,8.31690436 L6.17279985,8.31690436 L6.17279985,10.2401426 Z M2.02409527,10.2401426 L3.89622858,10.2401426 L3.89622858,8.31690436 L2.02409527,8.31690436 L2.02409527,10.2401426 Z M6.17279985,14.6582075 L8.04540953,14.6582075 L8.04540953,12.6830956 L6.17279985,12.6830956 L6.17279985,14.6582075 Z M2.02409527,14.6582075 L3.89622858,14.6582075 L3.89622858,12.6830956 L2.02409527,12.6830956 L2.02409527,14.6582075 Z",
    id: "Fill-2"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavAgencies);
export default __webpack_public_path__ + "static/media/navAgencies.328f217b.svg";
export { ForwardRef as ReactComponent };